import { createSelector } from '@reduxjs/toolkit';

// Base selector for auth state
const selectAuth = state => state.auth;

// Memoized selectors
export const selectAuthState = createSelector(
  [selectAuth],
  auth => ({
    isAuthenticated: auth?.isAuthenticated ?? false,
    user: auth?.user ?? null
  })
);

// Individual selectors if needed separately
export const selectIsAuthenticated = createSelector(
  [selectAuth],
  auth => auth?.isAuthenticated ?? false
);

export const selectUser = createSelector(
  [selectAuth],
  auth => auth?.user ?? null
); 